const initialBalanceState = {
  processing: false,
  processed: false,
  saving: false,
  saved: false,
  error: null,
  accountingDates: [],
  startDate: null,
  sourceModel: null,
  mensuelConfig: {
    oneMonth: "janvier",
    firstMonth: "janvier",
    lastMonth: "janvier"
  },
  trimesterConfig: {
    firstTrimester: 1,
    lastTrimester: 4
  },
  modelConfig: [],
  multipleModelConfig: [],
  // modelConfig: {
  //   years: [],
  //   months: []
  // },
  balanceAttachment: null,
  annexeConfig: {
    category: null,
    year: null
  },
  annexeAttachment: null,
  organization: null
};

export const balanceReducer = (state = initialBalanceState, action) => {
  switch (action.type) {
    case "INIT_BALANCE": {
      return { ...initialBalanceState };
    }
    case "SET_BALANCE_ORGANIZATION": {
      return { ...state, organization: { ...action.organization } };
    }
    case "SET_BALANCE_START_DATE": {
      return { ...state, startDate: action.startDate };
    }
    case "SET_BALANCE_ACCOUNTING_DATES": {
      return { ...state, accountingDates: action.accountingDates };
    }
    case "SET_BALANCE_SOURCE_MODEL": {
      return { ...state, sourceModel: action.sourceModel };
    }
    case "SET_BALANCE_MODEL_CONFIG": {
      return { ...state, modelConfig: action.modelConfig };
    }
    case "SET_BALANCE_MULTIPLE_MODEL_CONFIG": {
      return { ...state, multipleModelConfig: action.multipleModelConfig };
    }
    case "SET_BALANCE_ATTACHMENT": {
      return { ...state, balanceAttachment: action.balanceAttachment };
    }
    case "SELECT_ANNEXE_CATEGORY": {
      return {
        ...state,
        annexeConfig: { ...state.annexeConfig, category: action.category }
      };
    }
    case "SELECT_ANNEXE_YEAR": {
      return {
        ...state,
        annexeConfig: { ...state.annexeConfig, year: action.year }
      };
    }
    case "SET_ANNEXE_ATTACHMENT": {
      return { ...state, annexeAttachment: action.annexeAttachment };
    }
    case "SELECT_FIRST_MONTH": {
      return {
        ...state,
        mensuelConfig: { ...state.mensuelConfig, firstMonth: action.month }
      };
    }
    case "SELECT_LAST_MONTH": {
      return {
        ...state,
        mensuelConfig: { ...state.mensuelConfig, lastMonth: action.month }
      };
    }
    case "SELECT_ONE_MONTH": {
      return {
        ...state,
        mensuelConfig: { ...state.mensuelConfig, oneMonth: action.month }
      };
    }
    case "SELECT_FIRST_TRIMESTER": {
      return {
        ...state,
        trimesterConfig: {
          ...state.trimesterConfig,
          firstTrimester: action.trimester
        }
      };
    }
    case "SELECT_LAST_TRIMESTER": {
      return {
        ...state,
        trimesterConfig: {
          ...state.trimesterConfig,
          lastTrimester: action.trimester
        }
      };
    }
    case `SAVE_ACCOUNTING_DATES_PENDING`: {
      return { ...state, saved: false, saving: true };
    }
    case `SAVE_ACCOUNTING_DATES_FULFILLED`: {
      return {
        ...state,
        saving: false,
        saved: true
      };
    }
    case `SAVE_ACCOUNTING_DATES_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saved: false,
        error
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/balance.js